


































import { Button, Field, Form, Popup, Toast } from "vant";
import LinkAccount from "@/views/h5-page/account/Component/LinkAccount.vue";
import PopupHeader from "@/views/h5-page/account/Component/PopupHeader.vue";
import { PropType } from "vue";

export default {
  name: "AccountDetail",
  components: {
    PopupHeader,
    LinkAccount,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object
    },
    accountList: {
      type: Array
    }
  },
  computed: {
    enable(): boolean {
      const password = (this as any).password;
      return password !== null && password.length > 0;
    },
    accountShow(): string {
      return (
        (this as any).account.u_user_id + " " + (this as any).account.real_name
      );
    }
  },
  data() {
    return {
      active: 0,
      list: [],
      loading: false,
      finished: true,
      showLinkAccount: false,
      needRefreshOnClose: false,
      linkAccount: {},
    };
  },
  methods: {
    close() {
      this.linkClose();
      (this as any).$emit("close", (this as any).needRefreshOnClose);
    },
    //添加组 得先判断账户是否连接
    showLink(item) {
	  Toast.resetDefaultOptions();	
      if ((this as any).account.status === 1) {
        const data = {
          futures_login_id: item.futures_login_id,
          id: (this as any).account.id
        };
        (this as any).$apis
          .addgroupTrade(data)
          .then(res => {
            Toast("添加成功");
            this.close();
               //添加分组完成，刷新列表
            (this as any).$emit("success");
          })
          .catch(e => {
            
          });
      } else {
        (this as any).account.type = 1;
        (this as any).linkAccount = (this as any).account;
        (this as any).showLinkAccount = true;

      }
    },
    linkClose() {
      (this as any).showLinkAccount = false;
    },
    linkSuccess() {
      (this as any).$emit("success");
      (this as any).needRefreshOnClose = true;
    }
  }
};
